import { render, staticRenderFns } from "./Permision.vue?vue&type=template&id=e9890548&scoped=true"
import script from "./Permision.vue?vue&type=script&lang=js"
export * from "./Permision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9890548",
  null
  
)

export default component.exports